import { TDestinationCredentials } from '@/core/apis/config_api/config_api_types';
import { TMableEvent } from '@/core/constants/event_types/base_mable_event';
import { EMableEventName } from '@/core/constants/event_types/events';
import { EDestinationType } from '@/core/interfaces';

import {
  DestinationBundle,
  DestinationPayload,
  DestinationSendingResult,
} from '../abstract';

import { BrowserInstanceData } from '../../../core/data_handlers/browser_instance/index';

// Example implementation of DestinationBundle for ExampleDestinationType
export class ExampleDestinationBundle extends DestinationBundle {
  override allowedEvents: EMableEventName[] = [
    EMableEventName.PAGE_VIEWED,
    EMableEventName.PRODUCT_ADDED,
    EMableEventName.CHECKOUT_STARTED,
    EMableEventName.PAYMENT_INFO_ADDED,
    EMableEventName.PRODUCT_VIEWED,
    EMableEventName.LEAD,
    EMableEventName.COLLECTION_VIEWED,
    EMableEventName.ORDER_COMPLETED,
  ];
  constructor(
    destinationSetting: TDestinationCredentials,
    destinationId: string,
  ) {
    super(EDestinationType.Example, destinationSetting, destinationId);
  }

  override async init(bid: BrowserInstanceData): Promise<void> {
    void super.init(bid);
  }

  override calculatePayload(
    mableEvent: TMableEvent,
    // shouldSend: boolean,
    // consent: any,
  ): DestinationPayload {
    // Calculate the payload using the transform method

    return {
      // Example payload
      event: mableEvent,
      // consent,
      // shouldSend,
    };
  }

  override async sendToDestination(
    payload: DestinationPayload,
  ): Promise<DestinationSendingResult> {
    // Mock sending to destination and return a result
    // Logger.info('Sending payload to ExampleDestination:', payload);
    return {
      destinationReqEvent: payload,
      reason: 'Payload successfully sent',
      success: true,
    };
  }
}
